import { PersonaFisicaDTO } from "./persona-fisica-dto";
import { PersonaGiuridicaDTO } from "./persona-giuridica-dto";

export class ProprietarioDTO {
	codiceDelega: string;
	idPersona: string;
	nonReperibile: boolean;
	personaFisica: PersonaFisicaDTO;
	personaGiuridica: PersonaGiuridicaDTO;
	tipoRappresentante: string;
}
